// extracted by mini-css-extract-plugin
module.exports = {"link":"UserMailToLink_link__28rwB"};